import cx from 'classnames';
import { brandLogo } from '../utils/constants';
export function Logo({ className }) {
    return (<a href="https://napervilleparksil.comcate.com/en" target="_blank" rel="noopener noreferrer" className={cx('nav-logo', className)}>
    <img src={brandLogo} width="237px" className="nav-logo-img"/>  
    </a>);
}
